import dayjs from 'dayjs'

export const DATE_FORMAT = 'DD MMMM YYYY'

export const getDate = (date: string) => {
  return dayjs(date).format(DATE_FORMAT)
}

export const getFutureMonth = (numberOfMonths: number, withYear: boolean = false) => {
  const currentDate = new Date()
  currentDate.setMonth(currentDate.getMonth() + numberOfMonths)

  if (withYear) {
    return currentDate.toLocaleString('en', { month: 'long', year: 'numeric' })
  } else {
    return currentDate.toLocaleString('en', { month: 'long' })
  }
}
